import React from "react";
import { Link } from "react-router-dom";

import { IActiveLearningMaterial } from "../../state";
import { activeLearningThemesPath } from "../../teacherStore";
import Button from "../../atoms/ActiveLearning/Button";

import styles from "./activeLearningMaterial.module.scss";

export interface ActiveLearningMaterialProps {
  active_learning_material: IActiveLearningMaterial;
  openGuideline: (teaching_material_id: string, lesson_id: number) => void;
  openProjection: (teaching_material_id: string, lesson_id: number) => void;
  openMaterials: (
    active_learning_material_code: string,
    lesson_no: number,
  ) => void;
  classList: number[];
  calling: boolean;
}

const ActiveLearningMaterial = ({
  active_learning_material,
  openGuideline,
  openProjection,
  openMaterials,
  classList,
}: ActiveLearningMaterialProps) => {
  const goToNextScreen = React.useCallback(
    (lessonId: number) => {
      openGuideline(active_learning_material?.mitsuwa_id || "", lessonId);
    },
    [openGuideline, active_learning_material.mitsuwa_id],
  );
  const goToProjection = React.useCallback(
    (lessonId: number) => {
      openProjection(active_learning_material?.mitsuwa_id || "", lessonId);
    },
    [openProjection, active_learning_material.mitsuwa_id],
  );

  return (
    <div className={styles.activeLearningMaterial}>
      {active_learning_material.lessons?.map(l => (
        <div key={l.id} className={styles.lesson}>
          <div className={styles.label}>
            {l.no !== 0 && (
              <>
                <span className={styles.text}>LESSON</span>
                <span className={styles.no}>
                  {l.no && l.no < 10 ? `0${l.no}` : l.no}
                </span>
              </>
            )}
          </div>
          <div className={styles.title}>{l.title}</div>
          <div className={styles.btnWrapper}>
            <Button
              variant={"primary"}
              width={"74px"}
              height={"37px"}
              fontSize={"14px"}
              handleClick={() => goToNextScreen(l.id)}
            >
              指導書
            </Button>
            {l.no !== 0 && (
              <Button
                variant={"secondary"}
                width={"88px"}
                height={"37px"}
                fontSize={"14px"}
                handleClick={() => goToProjection(l.id)}
              >
                投影画面
              </Button>
            )}
            {l.no !== 0 && (
              <Button
                variant={"secondary"}
                width={"102px"}
                height={"37px"}
                fontSize={"14px"}
                handleClick={() =>
                  openMaterials(
                    active_learning_material?.mitsuwa_id ?? "",
                    l.no,
                  )
                }
              >
                生徒用教材
              </Button>
            )}
            {l.no === 1 && (
              <Link
                to={`${activeLearningThemesPath}?classList=${classList}&code=${active_learning_material?.mitsuwa_id}`}
              >
                <Button
                  variant={"secondary"}
                  width={"130px"}
                  height={"37px"}
                  fontSize={"14px"}
                >
                  企業テーマ一覧
                </Button>
              </Link>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActiveLearningMaterial;
